import {
  jsonSchema,
  type ModelMessage,
  isStepCount,
  streamText,
  toUIMessageStream,
  tool,
  type UIMessageStreamWriter,
} from 'ai';

import { type Subagent } from './mcpClient';
import { dixaGateway } from './provider';
import { type MimUIMessage } from './structuredResponse';

type SubagentInput = {
  query: string;
};

/** stopWhen defaults to 1,
 *  which means that it stops immediately after processing the strucuted output.
 *  Set to 10 so that we have some "budget" to call tools.
 *  See https://ai-sdk.dev/docs/reference/ai-sdk-core/stream-text#stop-when
 */
const STEP_COUNT = 10;

const inputSchema = jsonSchema<SubagentInput>({
  type: 'object',
  properties: {
    query: {
      type: 'string',
      description: 'Plain-English question for the subagent to answer.',
    },
  },
  required: ['query'],
});

export const createSubagentTool = (
  subagent: Subagent,
  chatId: string,
  writer: UIMessageStreamWriter<MimUIMessage>,
) =>
  tool<SubagentInput, string, Record<string, unknown>>({
    description: subagent.description,
    inputSchema,
    metadata: { stateCopy: subagent.stateCopy ?? {} },
    execute: async ({ query }, { abortSignal, messages }) => {
      const result = streamText({
        model: dixaGateway(subagent.prompt),
        messages: [
          ...messages,
          { role: 'user', content: query } as ModelMessage,
        ],
        tools: subagent.tools,
        abortSignal,
        headers: { traceparent: `00-${chatId}-4fe7d85c49cf1379-01` },
        stopWhen: isStepCount(STEP_COUNT),
      });

      writer.merge(
        toUIMessageStream({
          stream: result.stream,
          sendStart: false,
          sendFinish: false,
        }),
      );

      return await result.text;
    },
  });
